import { useCallback, useState } from "react";

export function useNewAttribute<T>(addAttribute: (attributeNew: T) => void) {
  const [newOpen, setNewOpen] = useState(false);

  const onNewClose = useCallback(() => {
    setNewOpen(false);
  }, []);

  const onNewApply = useCallback(
    (attributeNew: T) => {
      addAttribute(attributeNew);
      setNewOpen(false);
    },
    [addAttribute],
  );

  return {
    newOpen,
    setNewOpen,
    onNewClose,
    onNewApply,
  };
}
